import {
  Bell,
  FileText,
  ListChecks,
  Mail,
  MessageSquareReply,
  MessageSquareShare,
  MessageSquareText,
  StickyNote,
} from "lucide-react";

export const getNotificationVisual = (eventType: string) => {
  if (eventType === "MATTER_SMS_RECEIVED") {
    return {
      Icon: MessageSquareReply,
      className: "bg-[#cef7e2] text-[#009e62]",
      color: "#009e62",
    };
  }

  if (eventType === "MATTER_SMS_SENT") {
    return {
      Icon: MessageSquareShare,
      className: "bg-[#e0e7ff] text-[#4f46e5]",
      color: "#4f46e5",
    };
  }

  return eventType.includes("TASK")
    ? {
        Icon: ListChecks,
        className: "bg-[#dcebff] text-[#1769ff]",
        color: "#1769ff",
      }
    : eventType.includes("EMAIL")
      ? {
          Icon: Mail,
          className: "bg-[#ffe1e3] text-[#f5222d]",
          color: "#f5222d",
        }
      : eventType.includes("SMS")
        ? {
            Icon: MessageSquareText,
            className: "bg-[#cef7e2] text-[#009e62]",
            color: "#009e62",
          }
        : eventType.includes("NOTE")
          ? {
              Icon: StickyNote,
              className: "bg-[#eee7ff] text-[#7a36ff]",
              color: "#7a36ff",
            }
          : eventType.includes("FILE")
            ? {
                Icon: FileText,
                className: "bg-[#dcebff] text-[#1769ff]",
                color: "#1769ff",
              }
            : {
                Icon: Bell,
                className: "bg-[#ffe1e3] text-[#f5222d]",
                color: "#f5222d",
              };
};
